import "./loading.css"

const Loading = () => {
    return (
    //   <div className="spinner-wrapper">
    //     <div className="red-spinner" />
    //   </div>
    <div className="red-spinner" />
    );
}

export default Loading;